module.exports = __webpack_public_path__ + "static/media/lapsc.0b65e34c.png";